export const propFaqBooking = {
  faqEditor: {
    empty: "Aún no hay preguntas. Añade la primera para que el agente sepa responderla.",
    learnedTooltip: "Respuesta incorporada por autoaprendizaje del anfitrión",
    learnedBadge: "Aprendida",
    removeAttachment: "Quitar adjunto",
    uploading: "Subiendo…",
    attach: "Adjuntar",
    deleteTooltip: "Eliminar",
    addQuestion: "Añadir pregunta",
    qPlaceholder: "Pregunta · Ej: ¿Hay parking?",
    aPlaceholder: "Respuesta · Ej: Sí, gratuito en la puerta.",
    errors: {
      fillBeforeAttach: "Escribe la pregunta y la respuesta antes de adjuntar archivos.",
      saveBeforeAttach: "Guarda primero para poder adjuntar archivos.",
      uploadFailed: "No se pudo subir el archivo.",
      deleteFailed: "No se pudo eliminar el archivo.",
    },
  },
  faqSuggestions: {
    title: "Sugerencias para aprender",
    intro: "El agente no supo responder estas preguntas y tú respondiste al huésped. Revisa, edita si hace falta y guárdalas para que el agente las responda solo a partir de ahora.",
    askedLabel: "El huésped preguntó",
    questionLabel: "Pregunta",
    questionPlaceholder: "¿Cómo formularías la pregunta?",
    answerLabel: "Respuesta del agente",
    answerPlaceholder: "Respuesta que dará el agente",
    applyToOthers: "Aplicar también a otras unidades del anuncio:",
    dismiss: "Descartar",
    saveAsAnswer: "Guardar como respuesta",
    errors: {
      saveFailed: "No se pudo guardar.",
      dismissFailed: "No se pudo descartar.",
    },
  },
  sourceNote: {
    title: "Orden de prioridad de las respuestas del agente",
    infoAria: "Ver el orden de prioridad de las fuentes del agente",
    lead: "Cuando dos fuentes dicen algo distinto sobre el mismo dato, el agente sigue este orden:",
    faqPre: "Preguntas frecuentes ",
    faqStrong: "por unidad individual",
    faqTag: "manda",
    configMain: "Configuración del alojamiento",
    configMuted: "· horarios, capacidad, servicios",
    kb: "Base de conocimiento",
  },
  bookingLinks: {
    title: "Cómo reserva el huésped",
    subPre: "El agente envía el enlace de tus ",
    subStrong: "Reservas Directas",
    subPost: " y el huésped reserva por la web.",
    step1Pre: "Si indica un ",
    step1Strong: "alojamiento concreto",
    step1Post: ", el agente envía su enlace directo.",
    step2Pre: "Si hay ",
    step2Strong1: "varios en esa zona",
    step2Mid: ", le ",
    step2Strong2: "lista cada uno con su enlace",
    step2Post: " + el global.",
    step3Pre: "Si no sabe la zona, le ",
    step3Strong: "sugiere las zonas disponibles",
    step3Post: " y le pregunta dónde quiere.",
    globalLinkLabel: "Enlace global (todas las ubicaciones)",
    copy: "Copiar",
    copied: "Copiado",
    noIdNote: "El enlace de reservas se generará cuando tu cuenta tenga el identificador configurado.",
    toastCopied: "Enlace copiado",
    toastCopyFailed: "No se pudo copiar",
  },
  bookingConfirm: {
    title: "Notificar nueva reserva",
    subPre: "Cuando una reserva queda confirmada, avisamos automáticamente al huésped ",
    subStrong: "por WhatsApp",
    subPost: " con los datos de su estancia.",
    toggleLabel: "Enviar la confirmación por WhatsApp",
    toggleHint: "Si lo desactivas, no se enviará esta notificación al huésped. Si la reserva llega por una OTA, será la OTA quien le notifique.",
    stateOn: "Sí, enviar",
    stateOff: "No enviar",
    notEditablePre: "Por el momento, el contenido de este mensaje ",
    notEditableStrong: "no es editable",
    notEditablePost: ". Te mostramos una vista previa de lo que recibe el huésped.",
    previewTag: "Vista previa · lo que ve el huésped",
    online: "en línea",
    today: "Hoy",
    previewHint: "Se actualiza con tu configuración",
    defaultListingName: "Alojamiento",
    toastEnabled: "Notificación de reserva activada",
    toastDisabled: "Notificación de reserva desactivada",
    toastSaveFailed: "No se pudo guardar el cambio",
    previewGuest: "Laura García",
    previewBody: "Hola *{guest}* 👋\n\nTu reserva en *{name}* está confirmada ✅\n\nCódigo de reserva: *6233Q1VC5*\nFechas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp podrás solicitar tu link para el check-in online y, además, recibir las indicaciones de llegada.\nSi necesitas ayuda antes o durante la estancia, escríbenos por aquí 💬",
    previewCta: "🇪🇸 Para continuar con el check-in, pulsa el botón *Ok* o escribe *Ok*.",
  },
};
